import { useSearchParams } from 'react-router-dom'

interface UserCompanyPreset {
  initialCompanyId: number | undefined
  initialUserLevel: string
  initialUseCompanyAddress: boolean
}

/**
 * This hook returns the defaul values for the user form if a user is created directly for a specific company
 */
export const usePresetUserCompany = (): UserCompanyPreset => {
  const [searchParams] = useSearchParams()
  const companyUrlParam = searchParams.get('companyId')
  const initialCompanyId = companyUrlParam ? parseInt(companyUrlParam) : undefined
  const initialUserLevel = companyUrlParam ? 'INSTALLER' : ''
  const initialUseCompanyAddress = !!companyUrlParam

  return {
    initialCompanyId,
    initialUserLevel,
    initialUseCompanyAddress,
  }
}
